import React from 'react'
import { useSelector } from 'react-redux'
import dayjs from 'dayjs'

import { groupBy } from '../../common/utils'

const QToolsDeliveriesSMSHistory = ({ smss }) => {
  const customers = useSelector((s) => s.collectionData.customers)

  const groups = groupBy(smss || [], (item) => item.recipient)

  return (
    <div style={{ margin: 10 }} className="qSection">
      <h3>SMS-historik</h3>
      <div className="flex">
        {[...groups.values()].map((group) => {
          const [{ recipient }] = group

          const customer = customers.find((c) => c.phone === recipient)

          return (
            customer && (
              <div style={{ flex: 1, maxWidth: '45%', boxShadow: '2px 2px 8px 2px #e0e0e0', padding: 10, borderRadius: 3 }} key={recipient}>
                <h4 style={{ textAlign: 'center' }}>{`${customer.name} ${customer.surname} (${recipient})`}</h4>
                <hr />
                {group
                  .sort((a, b) => new Date(b.consumed) - new Date(a.consumed))
                  .map((sms) => (
                    <div key={sms._id} className="flex" style={{ marginTop: 10, flexDirection: 'column' }}>
                      <div style={{ alignSelf: 'center' }}>{dayjs(sms.consumed).format('D MMM HH:mm')}</div>
                      <div style={{ background: '#fff', borderRadius: 999, padding: 10 }}>{sms.messageCreated}</div>
                    </div>
                  ))}
              </div>
            )
          )
        })}
      </div>
    </div>
  )
}

export default QToolsDeliveriesSMSHistory
